import { FaPhone } from "react-icons/fa6";
import { IoEllipsisVerticalOutline } from "react-icons/io5";

const ShiekhCard = ({ shiekh, handleClick }) => {
  return (
    <div className="border p-4 rounded shadow flex items-center justify-between">
      <div className="flex items-center">
        <img
          src="https://png.pngtree.com/png-vector/20220520/ourmid/pngtree-iconic-avatar-of-an-islamic-man-in-traditional-muslim-attire-vector-png-image_45953174.jpg"
          alt="Shiekh"
          className="w-20 h-20 rounded-full mr-2"
        />
        <div>
          <h2 className="text-lg font-bold mb-2">{shiekh.firstName} {shiekh.lastName}</h2>
          <p className="flex items-center">
            <FaPhone className="mr-2 ml-2 text-primary-blue" /> {shiekh.phoneNumber}
          </p>
        </div>
      </div>
      <IoEllipsisVerticalOutline
        onClick={() => handleClick(shiekh.id)}
        className="cursor-pointer text-xl hover:bg-gray-200 hover:text-primary-blue rounded-full"
      />
    </div>
  );
};

export default ShiekhCard;
